<template>
    <div>
        <div class="breadcrumb_config row d-inline-flex justify-content-center align-items-center mt-1 mb-1">

            <!-- CONFIGURATORS -->
            <div
                class="navIcon"
                @click="pressedScreen('1')"
            >
                <div style="font-size:14px; font-weight: bold;">{{ $t('nav_titel_s1') }}</div>

                <img
                    id="img_1"
                    :src="app.currentConfiguration.stage >= 1 && !app.userIsInsideMyConfigs ? icon_on : icon_off"
                    alt
                    style="height: auto; width: 125px;"
                />

                <div v-if="app.currentConfiguration.configurator !== null">
                    <span style="word-wrap: break-word;">{{app.currentConfiguration.configurator.name}}</span>
                </div>
            </div>

            <!-- FAMILIES -->
            <div
                class="navIcon"
                @click="pressedScreen('2')"
            >
                <div style="font-size:14px; font-weight: bold;">{{ $t('nav_titel_s2') }}</div>

                <img
                    id="img_2"
                    :src="app.currentConfiguration.stage >= 2 && !app.userIsInsideMyConfigs ? icon_on : icon_off"
                    alt
                    style="height: auto; width: 125px;"
                />

                <div v-if="app.currentConfiguration.familyParameters.hasOwnProperty('gama')">
                    <span style="word-wrap: break-word;">{{ app.currentConfiguration.familyParameters['gama'].value.name}}</span>
                </div>
            </div>

            <!-- MAIN ELEMENT -->
            <div
                class="navIcon"
                @click="pressedScreen('3')"
            >
                <div style="font-size:14px; font-weight: bold;">{{ $t('nav_titel_s3') }}</div>

                <img
                    id="img_3"
                    :src="app.currentConfiguration.stage >= 3 && !app.userIsInsideMyConfigs ? icon_on : icon_off"
                    alt
                    style="height: auto; width: 125px;"
                />
            </div>

            <!-- RESULTS -->
            <div
                class="navIcon"
                @click="pressedScreen('4')"
            >
                <div style="font-size:14px; font-weight: bold;">{{ $t('nav_titel_s4') }}</div>

                <img
                    id="img_4"
                    :src="app.currentConfiguration.stage >= 4 && !app.userIsInsideMyConfigs ? icon_on : icon_off"
                    alt
                    style="height: auto; width: 125px;"
                />
            </div>

            <!-- ------------------ -->
            <!-- MY CONFIGURATIONS -->
            <!-- ------------------ -->
            <div v-if="app.auth.enabled" class="navIcon ml-5">
                <div class="text-center" style="font-size:14px; font-weight: bold;">{{ $t('nav_titel_my_configs') }}</div>
                <img
                    id="img_5"
                    :src="app.userIsInsideMyConfigs ? icon_on : icon_off"
                    alt
                    @click="pressedScreen('myConfigs')"
                    style="height: auto; width:125px"
                />
            </div>



        </div>
    </div>
</template>

<style scoped lang="scss">

.breadcrumb_config {
    position: relative;
}

.navIcon {
    width: 125px;
    height: 150px;
    cursor: pointer;
    font-size: 0.95rem;
    line-height: 1.3;
}
.navIconGestorConfig {
    width: 125px;
    cursor: pointer;
}
</style>



<script>
import { app } from "../application.js";

export default {
    name: "navigationbarComponent",
    props: ["infoNavigationbar"],
    data() {
        return {
            app,
            icon_on: require("@/assets/images/navigationbar/On.png"),
            icon_off: require("@/assets/images/navigationbar/Off.png")
        };
    },

    methods: {
        pressedScreen: function(screen) {

            //is stage is not myConfigs navigate normally
            if (screen === "1") {
                app.navigateToStageAsync("1");

            } else if (screen === "2" && this.app.currentConfiguration.configurator && this.app.currentConfiguration.configurator.id) {
            //} else if (screen === "2" ) {

                app.navigateToStageAsync("2");

            } else if (screen === "3") {

                app.currentConfiguration.stage > 3 ? this.app.navigateToStageAsync("3") : "";

            } else if (screen === "4") {

                app.currentConfiguration.stage === 4
                    ? app.navigateToStageAsync("4")
                    : "";

            } else if (screen === "myConfigs") {
                this.app.routerPush("myConfigs");

                // //si no esta logejat portal directament a logejarse
                // if(this.app.auth.isLogged){

                // //si ja està logejat portal a la pagina de mis configuraciones
                // }else{
                //     this.app.auth.login();

                // }
            }
        },

        saveCurrentConfig: function() {
            let self = this;

            //Here the message could be stored in the app depending on the language
            let infoModal = {
                modalToShow: "saveCurrentConfig",
                title: "Guarda la configuración actual",
                html_message: `
                    <div class="form-group row mt-0 mb-2 mr-3 ml-3 d-flex flex-row align-items-center">

                        <div class="d-block text-left mb-3">
                            <h5>Indica con qué nombre quieres guardar esta configuración:</h5>
                        </div>

                        <label for="inputName" class="col-2">Nombre:</label>
                        <div class="col-10">
                            <input type="text" class="form-control" id="inputName" />
                        </div>
                    </div>
                `,
                message: "",
                showConfirmationButton: true,
                showCancelButton: true,
                textConfirmationButton: "Si",
                textCancelButton: "No"
            };

            //ES6 destructuring object resolved from promise:
            self.app
                .showModal(infoModal)
                .then(({ userAction, paramResult }) => {
                    if (userAction === "modal_rejected") {
                        //do nothing
                    } else if (userAction === "modal_confirmed") {

                    }
                });
        },

        showAccesDeniedOrRedirectToUserConfigs: function() {
            if (this.app.auth.isLogged) {
                app.showMyConfigs();
            } else {
                let self = this;
                let infoModal = {
                    modalToShow: "showAccesDenied",
                    title: "Login",
                    html_message: "",
                    message: "Logeate para acceder a tus configuraciones.",
                    showConfirmationButton: false,
                    showCancelButton: true,
                    textConfirmationButton: "Si",
                    textCancelButton: "No"
                };

                self.app
                    .showModal(infoModal)
                    .then(({ userAction, paramResult }) => {
                        if (userAction === "modal_rejected") {
                            //do nothing
                        } else if (userAction === "modal_confirmed") {
                        }
                    });
            }
        }
    },
    components: {}
};
</script>
